<template>
  <div class="z-75 right-0 fixed flex flex-col items-end mr-6" :class="[isSubpage ? 'top-28' : 'top-36']">
    <FeedbackButton />
    <slot name="page__actions"></slot>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import FeedbackButton from '~/modules/feedback/components/FeedbackButton';

export default defineComponent({
  components: { FeedbackButton },
  props: {
    isSubpage: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
